module.exports = __webpack_public_path__ + "static/img/shier.74bd372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shier.png
// module id = q2GJ
// module chunks = 1